import React from 'react';
import { useState } from "react"
import { FiArchive,FiMoreVertical, FiTrash2, FiUsers, FiVolumeX, FiX } from 'react-icons/fi'
import { useDrawer } from '../../../../stores/useDrawer';

const Option = () => {
  const drawer = useDrawer(state=>state)    
  const openDetail = () => drawer.open({type:'messenger-detail'})
    const [status, setStatus] =useState(false)
    return (
      <div class="relative">
      {/** OPTIONS COMPONENT **/}
          <div
          // @click.away="status=false"
         onClick={()=>setStatus(!status)}
        >
          <div class="">
            <FiMoreVertical size={23}
              class="text-gray-400 cursor-pointer"
            /> 
          </div>
      {status && (
  
          <div
            // :class="status == true ? 'block' :'hidden'"
            class="dropdown absolute right-0 top-6 z-10 divide-y border dark:border-zinc-700 bg-white dark:bg-zinc-800 rounded-lg w-32"
          >
            <ul class="py-2 text-sm text-gray-200">
              <li
                class="md:hidden cursor-pointer"
                onClick={openDetail}
              >
                <div
                  class="block text-zinc-500 hover:bg-zinc-200 dark:text-zinc-300 dark:hover:bg-zinc-900 px-4 py-2 flex gap-1 items-center"
                >
                  <FiUsers
                    class="h-4 text-zinc-600 dark:text-zinc-300"
                  />
                  <p>Detail</p>
                </div>
              </li>
              <li>
                <a
                  href="#"
                  class="block text-zinc-500 hover:bg-zinc-200 dark:text-zinc-300 dark:hover:bg-zinc-900 px-4 py-2 flex gap-1 items-center"
                >
                  <FiArchive
                    class="h-4 text-zinc-600 dark:text-zinc-300"
                  />
                  <p>Archive</p>
                </a>
              </li>
              <li>
                <a
                  href="#"
                  class="block text-zinc-500 hover:bg-zinc-200 dark:text-zinc-300 dark:hover:bg-zinc-900 px-4 py-2 flex gap-1 items-center"
                >
                  <FiVolumeX
                    class="h-4 text-zinc-600 dark:text-zinc-300"
                  />
                  <p>Muted</p>
                </a>
              </li>
              <li>
                <a
                  href="#"
                  class="block text-zinc-500 hover:bg-zinc-200 dark:text-zinc-300 dark:hover:bg-zinc-900 px-4 py-2 flex gap-1 items-center"
                >
                  <FiTrash2
                    class="h-4 text-zinc-600 dark:text-zinc-300"
                  />
                  <p>Delete</p>
                </a>
              </li>
              <li>
                <a
                  href="#"
                  class="block text-zinc-500 hover:bg-zinc-200 dark:text-zinc-300 dark:hover:bg-zinc-900 px-4 py-2 flex gap-1 items-center"
                >
                  <FiX
                    class="h-4 text-zinc-600 dark:text-zinc-300"
                  />
                  <p>Close</p>
                </a>
              </li>
            </ul>
          </div>
      )}
        </div>
    </div>
    )
}
  
export default Option;